import React, { useEffect, useState } from 'react'
import styles from '../../../../../styles/david-fonts.module.css'
import classNames from 'classnames'
import { Text, TextProps } from '@/atoms/Text'
import { colors } from '@/constants/colors'

interface Props extends Omit<TextProps, 'face'> {
  face?: 'royal-loudes-rough' | 'royal-loudes'
}

const color = '#5C428F'

const DavidStyledText: React.FC<Props> = ({ face, style, className, ...textProps }) => {
  const [fontsLoaded, setFontsLoaded] = useState(false)
  const resolvedStyle = { ...style, color: textProps.color ? colors[textProps.color] : color }
  const resolvedFaceClassName =
    face === 'royal-loudes-rough' ? styles['font-royal-loudes-rough'] : styles['font-royal-loudes']

  // Wait for custom fonts to load before showing text
  useEffect(() => {
    if (!document.fonts) setFontsLoaded(true)

    document.fonts.ready
      .then(() => {
        setFontsLoaded(true)
      })
      .catch(() => {
        setTimeout(() => setFontsLoaded(true), 500)
      })
  }, [])

  return (
    <Text
      {...textProps}
      face={'inherit' as TextProps['face']}
      style={resolvedStyle}
      className={classNames(
        className,
        resolvedFaceClassName,
        'leading-[0.75em] transition-opacity duration-500 ease-out',
        { 'opacity-0': !fontsLoaded },
      )}
    />
  )
}

export default DavidStyledText
